module.exports = __webpack_public_path__ + "static/mysa-mattress-5-4f581d3c309a8098c91ec1f6e3ac671c.png";